import classNames from "classnames"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"

import styles from "./AtomButton.module.scss"

export type Props = ComponentPropsWithoutRef<"button">

// TODO the clickable area for this should probably be bigger
// renders a rectangular <button />
export const AtomButton = forwardRef<HTMLButtonElement, Props>(
  function AtomButton(props: Props, propRef: Ref<HTMLButtonElement>) {
    const className = classNames(
      props.className,
      styles.atomButton,
    )

    return (
      <button
        type="button"
        {...props}
        ref={propRef}
        className={className}
      />
    )
  },
)
